module.exports = __webpack_public_path__ + "media/nujabes-tsurugi-no-mai.87294113.mp3";